import React from 'react';
import { Box, Typography, Fade } from '@mui/material';
import styles from './SuggestByType.module.scss';
import HdLink from '../../../link/components/link/HdLink';
import { HdSupportButton } from '../support-button/SupportButton';

interface SuggestProps {
  suggestionContext: { name: string; value: string };
  actionHandler: Function;
}

export default function SuggestByType({ suggestionContext, actionHandler }: SuggestProps) {

  return (
    <div className={styles.helperWrapper}>
      <Fade in>
        <Box className={styles.helper}>
          <Typography component='span' className={styles.helperText}>
            Can't find the {suggestionContext.name} you are looking for? 😞.{' '}
            <HdSupportButton
              tag='button'
              dataId={`${suggestionContext.name}-suggest`}
              Component={HdLink}
              onClick={() => actionHandler()}
            >
              Connect with our Support Team
            </HdSupportButton>
          </Typography>
        </Box>
      </Fade>
    </div>
  );
}
